import { createIcon } from '../createIcon';

export const FileImportIconConfig = {
  name: 'FileImportIcon',
  height: 512,
  width: 512,
  svgPath: 'M128 64c0-35.3 28.7-64 64-64H352V128c0 17.7 14.3 32 32 32H512V448c0 35.3-28.7 64-64 64H192c-35.3 0-64-28.7-64-64V336H302.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H128V64zm0 224v48H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H128zM512 128H384V0L512 128z',
  yOffset: 0,
  xOffset: 0
};

export const FileImportIcon = createIcon(FileImportIconConfig);

export default FileImportIcon;